import { render, staticRenderFns } from "./AddAttribute.vue?vue&type=template&id=4c1cb966&scoped=true&"
import script from "./AddAttribute.vue?vue&type=script&lang=js&"
export * from "./AddAttribute.vue?vue&type=script&lang=js&"
import style0 from "./AddAttribute.vue?vue&type=style&index=0&id=4c1cb966&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c1cb966",
  null
  
)

export default component.exports